"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRow = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const dateFormatter_1 = require("../../helper/dateFormatter");
const theme_1 = require("../../theme");
const DateRow = ({ date }) => (react_1.default.createElement(react_native_1.View, { style: styles.row },
    react_1.default.createElement(react_native_1.Text, { style: [styles.timeStamp] }, dateFormatter_1.formatDateForConversationListEntries(date))));
exports.DateRow = DateRow;
const styles = react_native_1.StyleSheet.create({
    row: {
        alignItems: 'center',
        marginVertical: 20,
    },
    timeStamp: {
        fontFamily: theme_1.fontFamilyAlternate,
        fontSize: 13,
        fontWeight: '300',
    },
});
